import * as types from './types'
import moment from 'moment'

export default {
  [types.RESET_BAYS](state, firm) {
    state.bays = []
    state.slots = []
    state.bay = JSON.parse(JSON.stringify(state.defaultBay))
    state.bay.firm = firm
    state.selectedSlot = null
  },
  [types.INIT_BAY](state, firm) {
    state.bay = JSON.parse(JSON.stringify(state.defaultBay))
    state.bay.firm = firm
  },
  [types.UPDATE_BAY](state, data) {
    if (state.bay !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.bay.firm = parseInt(data.value)
          break
        case 'bayName':
          state.bay.bayName = data.value
          break
        case 'startOfDay':
          state.bay.startOfDay = data.value
          break
        case 'endOfDay':
          state.bay.endOfDay = data.value
          break
        case 'isInactive':
          state.bay.isInactive = data.value
          break
        case 'technician':
          state.bay.technician = data.value
          break
        case 'slots':
          state.bay.slots = 0
          if (data.value !== '') {
            state.bay.slots = parseInt(data.value)
          }
          break
        case 'avgSlotTime':
          state.bay.avgSlotTime = 0
          if (data.value !== '') {
            state.bay.avgSlotTime = parseInt(data.value)
          }
          break
        case 'block':
          if (state.bay.blocks === null) {
            state.bay.blocks = []
          }
          state.bay.blocks.push(data.value)
          break
        case 'removeBlock':
          state.bay.blocks.splice(data.value, 1)
          break
      }
    }
  },
  [types.SET_BAYS](state, data) {
    state.bays = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.bays = data
      }
    }
  },
  [types.SET_BAY](state, data) {
    state.bay = data
  },
  [types.SET_SLOTS](state, data) {
    state.slots = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.slots = data
      }
    }
    console.log('Got Slots', state.slots)
  },
  [types.SET_SLOT](state, data) {
    let found = null
    if (data !== undefined && data !== null) {
      switch (data.name) {
        case 'change-time':
          found = state.slots.find(x => parseInt(x.calibrate) === parseInt(data.value))
          if (found) {
            found.class = 'custom-slot-changing'
          }
          break
        case 'cancel-time-change':
          found = state.slots.find(x => parseInt(x.calibrate) === parseInt(data.value))
          if (found) {
            found.class = 'custom-slot'
          }
          break
        case 'save-time':
          let foundnew = state.slots.find(
            x =>
              x.start === moment(data.value.new.start).format('YYYY-MM-DD HH:mm') &&
              x.split === data.value.new.split
          )
          let foundold = state.slots.find(
            x =>
              x.start === moment(data.value.old.start).format('YYYY-MM-DD HH:mm') &&
              x.split === data.value.old.split
          )
          if (foundold) {
            foundold.start = moment(data.value.new.start).format('YYYY-MM-DD HH:mm')
            foundold.end = moment(data.value.new.end).format('YYYY-MM-DD HH:mm')
            foundold.split = data.value.new.split
            foundold.bay = data.value.new.split
          }
          if (foundnew) {
            foundnew.start = moment(data.value.old.start).format('YYYY-MM-DD HH:mm')
            foundnew.end = moment(data.value.old.end).format('YYYY-MM-DD HH:mm')
            foundnew.split = data.value.old.split
            foundnew.bay = data.value.old.split
          }
          break
      }
    }
  },
  [types.UPDATE_SLOT](state, data) {
    state.selectedSlot = null
    let start = moment(data.start).format('YYYY-MM-DD HH:mm')
    console.log('Updating the Slot', { slots: state.slots, bay: data.split, start: start })
    state.slots.forEach(slot => {
      slot.class = 'custom-slot'
      if (slot.start === start && slot.bay === data.split) {
        console.log('Found Slot', data)
        slot.class = 'custom-slot-highlight'
        state.selectedSlot = JSON.parse(JSON.stringify(slot))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bays/mutations.js